import { ApiClient } from './client';
import { sessionStore } from '../auth/sessionStore';

export * from './types';
export * from './errors';
export { ApiClient } from './client';
export type { ApiClientConfig, CommandOptions } from './client';

export const GATEWAY_QUERY_URL: string = import.meta.env.VITE_GATEWAY_QUERY ?? '/api/query';
export const GATEWAY_COMMAND_URL: string = import.meta.env.VITE_GATEWAY_COMMAND ?? '/api/command';

/**
 * Портальный контур подрядчика — ОТДЕЛЬНЫЙ шлюз (channel=portal). Вебхук
 * erp-portal-v1 проставляет канал на сервере, поэтому портальная сессия
 * физически не может выполнить операцию контура app: dispatch отдаст
 * permission_denied «Операция недоступна в этом канале».
 */
export const GATEWAY_PORTAL_QUERY_URL: string =
  import.meta.env.VITE_GATEWAY_PORTAL_QUERY ?? '/api/portal/query';
export const GATEWAY_PORTAL_COMMAND_URL: string =
  import.meta.env.VITE_GATEWAY_PORTAL_COMMAND ?? '/api/portal/command';

/** Прикладной клиент основного контура (channel=app). */
export const api = new ApiClient({
  queryUrl: GATEWAY_QUERY_URL,
  commandUrl: GATEWAY_COMMAND_URL,
  channel: 'app',
  getToken: () => sessionStore.getToken(),
  onUnauthenticated: () => sessionStore.clear('expired'),
});

/** Клиент портала подрядчика (channel=portal). Сессия та же, контур — другой. */
export const portalApi = new ApiClient({
  queryUrl: GATEWAY_PORTAL_QUERY_URL,
  commandUrl: GATEWAY_PORTAL_COMMAND_URL,
  channel: 'portal',
  getToken: () => sessionStore.getToken(),
  onUnauthenticated: () => sessionStore.clear('expired'),
});
